import { ActionIcon, Avatar, Group, Paper, Text, Tooltip } from "@mantine/core";
import { IconSettings, IconTrash } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import classes from "./WorkspaceDashboard.module.css";
import { useDeleteWorkspace } from "../../api/workspace";
import { useDeleteConfirm } from "../../hooks/useDeleteConfirm";

export function WorkspaceItem({ ws, isActive, onSelect, isAdmin }) {
  const navigate = useNavigate();

  const { mutate: deleteWorkspace } = useDeleteWorkspace();
  const confirmDelete = useDeleteConfirm("workspace", deleteWorkspace);

  return (
    <Paper
      key={ws.id}
      className={`${classes.workspaceCard} ${
        isActive ? classes.activeWorkspace : ""
      }`}
      onClick={() => onSelect(ws)}
    >
      <Group gap="sm" justify="space-between" wrap="nowrap">
        <Group gap="sm">
          <Avatar size="sm" color="blue">
            {ws.name[0]}
          </Avatar>
          <Text fw={600} size="sm">
            {ws.name}
          </Text>
        </Group>
        <Group gap="sm">
          <Tooltip label="Workspace Settings">
            <ActionIcon
              variant="subtle"
              color="gray"
              size="md"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/app/workspaces/${ws.id}`);
              }}
            >
              <IconSettings size={20} />
            </ActionIcon>
          </Tooltip>
          {isAdmin && (
            <Tooltip label="Delete Workspace">
              <ActionIcon
                variant="subtle"
                color="red"
                size="md"
                onClick={(e) => {
                  e.stopPropagation();
                  confirmDelete({ id: ws.id });
                }}
              >
                <IconTrash size={20} />
              </ActionIcon>
            </Tooltip>
          )}
        </Group>
      </Group>
    </Paper>
  );
}
